import { Validator, isRequired, validateEmailFormat } from '../../../common/hooks/useFormControls';

const requiredField = Validator(isRequired, 'This field is required');
const validEmail = Validator(validateEmailFormat, 'Please enter a valid email address');
const trimWhitespace = (value) => value.trim();

const articleLicensingForm = [
  {
    fieldName: 'newspost',
    label: 'Article link',
    value: '',
    validators: [requiredField],
    sanitizers: [trimWhitespace],
    description: 'Must be a valid Industry Dive article URL. ',
  },
  {
    fieldName: 'submitterName',
    label: 'Full name',
    value: '',
    validators: [requiredField],
    sanitizers: [trimWhitespace],
  },
  {
    fieldName: 'submitterEmail',
    label: 'Email address',
    value: '',
    validators: [requiredField, validEmail],
    sanitizers: [trimWhitespace],
  },
  {
    fieldName: 'submitterCompany',
    label: 'Company name',
    value: '',
    validators: [requiredField],
    sanitizers: [trimWhitespace],
  },
  {
    fieldName: 'submitterTitle',
    label: 'Job title',
    value: '',
    validators: [],
    sanitizers: [trimWhitespace],
  },
  {
    fieldName: 'subscribe',
    value: true,
    validators: [],
  },
];

export default articleLicensingForm;
export { requiredField };
